import React from "react";
import { HexColorPicker } from "react-colorful";
import { TinyColor } from "@ctrl/tinycolor";

import "./picker.css";

function getPixel(imgData, index) {
  const i = index * 4;
  const d = imgData.data;
  return [d[i], d[i + 1], d[i + 2], d[i + 3]];
}

function getPixelXY(imgData, x, y) {
  return getPixel(imgData, y * imgData.width + x);
}

export default class Picker extends React.Component {
  state = {
    color: this.props.color,
    hex: this.props.color,
    showModal: false,
    imported: null,
  };

  inputImport;

  triggerImport = () => {
    this.inputImport?.click();
  };

  triggerExport = (event) => {
    event.preventDefault();
    const canvas = document.getElementById("drawing-canvas");
    const link = document.createElement("a");
    link.setAttribute("download", "exported.png");
    link.setAttribute(
      "href",
      canvas.toDataURL("image/png").replace("image/png", "image/octet-stream")
    );
    link.click();
  };

  render() {
    const { onPartToggle } = this.props;

    const {
      color,
      onColorChange,
      showBody,
      showOverlay,
      hiddenParts,
      model,
      onModelChange,
      onImageImport,
      onToggleBody,
      onToggleOverlay,
    } = this.props;

    const colorInputStyle = {
      background: color,
      borderColor: new TinyColor(color).darken(15).toHexString(),
      color: new TinyColor(color).isLight() ? "black" : "white",
    };

    const onColorPick = (color) => {
      onColorChange(color);
      this.setState({ hex: color });
    };

    const onColorInput = (event) => {
      onColorChange(event.target.value);
      this.setState({ hex: event.target.value });
    };

    const onSkinChoose = (skin) => {
      const ctx = this;
      const image = this.state.imported;
      if (image) {
        const reader = new FileReader();

        reader.onload = function (e) {
          if (skin === "auto") {
            const canvas = document.getElementById("import-canvas");
            const context = canvas.getContext("2d");

            const texture = new Image();
            texture.src = e.target.result;
            texture.onload = () => {
              context.clearRect(0, 0, 64, 64);
              context.drawImage(texture, 0, 0);
              const imgData = context.getImageData(0, 0, 64, 64);
              const pix = getPixelXY(imgData, 46, 52);
              const pix1 = getPixelXY(imgData, 47, 52);
              const pix2 = getPixelXY(imgData, 46, 53);
              const pix3 = getPixelXY(imgData, 47, 53);
              const pix10 = getPixelXY(imgData, 54, 20);
              const pix11 = getPixelXY(imgData, 55, 20);
              const pix12 = getPixelXY(imgData, 54, 21);
              const pix13 = getPixelXY(imgData, 55, 21);

              if (
                (pix[0] === 0 &&
                  pix[1] === 0 &&
                  pix[2] === 0 &&
                  pix[3] === 0 &&
                  pix1[0] === 0 &&
                  pix1[1] === 0 &&
                  pix1[2] === 0 &&
                  pix1[3] === 0 &&
                  pix2[0] === 0 &&
                  pix2[1] === 0 &&
                  pix2[2] === 0 &&
                  pix2[3] === 0 &&
                  pix3[0] === 0 &&
                  pix3[1] === 0 &&
                  pix3[2] === 0 &&
                  pix3[3] === 0) ||
                (pix10[0] === 0 &&
                  pix10[1] === 0 &&
                  pix10[2] === 0 &&
                  pix10[3] === 255 &&
                  pix11[0] === 0 &&
                  pix11[1] === 0 &&
                  pix11[2] === 0 &&
                  pix11[3] === 255 &&
                  pix12[0] === 0 &&
                  pix12[1] === 0 &&
                  pix12[2] === 0 &&
                  pix12[3] === 255 &&
                  pix13[0] === 0 &&
                  pix13[1] === 0 &&
                  pix13[2] === 0 &&
                  pix13[3] === 255) ||
                (pix[0] === 255 &&
                  pix[1] === 255 &&
                  pix[2] === 255 &&
                  pix[3] === 255 &&
                  pix1[0] === 255 &&
                  pix1[1] === 255 &&
                  pix1[2] === 255 &&
                  pix1[3] === 255 &&
                  pix2[0] === 255 &&
                  pix2[1] === 255 &&
                  pix2[2] === 255 &&
                  pix2[3] === 255 &&
                  pix3[0] === 255 &&
                  pix3[1] === 255 &&
                  pix3[2] === 255 &&
                  pix3[3] === 255) ||
                (pix10[0] === 255 &&
                  pix10[1] === 255 &&
                  pix10[2] === 255 &&
                  pix10[3] === 255 &&
                  pix11[0] === 255 &&
                  pix11[1] === 255 &&
                  pix11[2] === 255 &&
                  pix11[3] === 255 &&
                  pix12[0] === 255 &&
                  pix12[1] === 255 &&
                  pix12[2] === 255 &&
                  pix12[3] === 255 &&
                  pix13[0] === 255 &&
                  pix13[1] === 255 &&
                  pix13[2] === 255 &&
                  pix13[3] === 255)
              ) {
                onModelChange("alex");
              } else {
                onModelChange("steve");
              }
            };
          } else {
            onModelChange(skin);
          }

          ctx.setState({ showModal: false });
          onImageImport(e.target.result);
        };

        reader.readAsDataURL(image);
      }
    };

    const showImportModal = (event) => {
      this.setState({ showModal: true, imported: event.target.files[0] });
    };

    return (
      <div className="picker">
        <ul className="item-list">
          <li>
            <div className="color-picker">
              <div className="react-picker">
                <HexColorPicker color={color} onChange={onColorPick} />
              </div>
              <div className="circle-picker">
                <input
                  value={this.state.hex}
                  onChange={onColorInput}
                  style={colorInputStyle}
                  maxLength={7}
                />
              </div>
            </div>
          </li>

          <li className="body-parts">
            <div className="d-flex justify-content-center">
              <span
                className={`btn-part ${showBody ? "active" : ""}`}
                onClick={onToggleBody} >
                Body
              </span>
              <span
                className={`btn-part ${showOverlay ? "active" : ""}`}
                onClick={onToggleOverlay} >
                Outer layer
              </span>
            </div>
            <div className="text-center">
              <div className="row d-flex justify-content-center">
                <div
                  className={
                    "body-part head " +
                    (hiddenParts.includes("Head") ? "disabled" : "")
                  }
                  onClick={() => onPartToggle("Head")}
                ></div>
              </div>
              <div className="row justify-content-center">
                <div
                  className={
                    "body-part arm " +
                    (hiddenParts.includes("RightArm") ? "disabled" : "")
                  }
                  onClick={() => onPartToggle("RightArm")}
                ></div>
                <div
                  className={
                    "body-part body " +
                    (hiddenParts.includes("Body") ? "disabled" : "")
                  }
                  onClick={() => onPartToggle("Body")}
                ></div>
                <div
                  className={
                    "body-part arm " +
                    (hiddenParts.includes("LeftArm") ? "disabled" : "")
                  }
                  onClick={() => onPartToggle("LeftArm")}
                ></div>
              </div>
              <div className="row justify-content-center">
                <div
                  className={
                    "body-part leg " +
                    (hiddenParts.includes("RightLeg") ? "disabled" : "")
                  }
                  onClick={() => onPartToggle("RightLeg")}
                ></div>
                <div
                  className={
                    "body-part leg " +
                    (hiddenParts.includes("LeftLeg") ? "disabled" : "")
                  }
                  onClick={() => onPartToggle("LeftLeg")}
                ></div>
              </div>
            </div>
          </li>

          <li>
            <div className="text-center">
              <select
                className="select-model"
                value={model}
                onChange={(event) => onModelChange(event.target.value)} >
                <option value="steve">Classic (4px)</option>
                <option value="alex">Slim (3px)</option>
              </select>
            </div>
          </li>

          <li className="d-flex justify-content-end">
            <span
              className="btn flex-center flex-column mr-1"
              onClick={this.triggerExport}
            >
              <img src="/assets/download.svg" height={60} alt="download" />
              <div className="small">Download</div>
            </span>

            <span
              className="btn flex-center flex-column"
              onClick={this.triggerImport}
            >
              <img src="/assets/upload.svg" height={60} alt="upload" />
              <div className="small">Upload</div>
              <input
                type="file"
                accept="image/png"
                className="d-none"
                ref={(input) => (this.inputImport = input)}
                onChange={showImportModal}
              />
            </span>
          </li>
        </ul>

        <div className={"import-modal " + (this.state.showModal ? "show" : "")}>
          <div className="title">Which type of skin is this?</div>
          <ul className="options">
            <li className="option active" onClick={() => onSkinChoose("auto")}>
              Decide it for me
            </li>
            <li className="option" onClick={() => onSkinChoose("steve")}>
              Classic (4 px arms)
            </li>
            <li className="option" onClick={() => onSkinChoose("alex")}>
              Slim (3 px arms)
            </li>
          </ul>
        </div>
      </div>
    );
  }
}
